<template>
  <b-card>
    <div slot="header">
      <strong>
        برای ضبط صدای مصاحبه ابتدا روی دکمه میکروفون (<i
          class="fas fa-microphone"
        ></i
        >) زده و بعد از پایان مکالمه روی دکمه توقف (<i class="fas fa-stop"></i>)
        بزنید
      </strong>
    </div>

    <b-row>
      <b-col
        class="text-center d-flex justify-content-center align-items-center"
        cols="12"
        md="6"
      >
        <div class="">
          <div class="my-3">
            <h5 v-if="audioTimer">
              زمان ضبط صدا
              <b class="text-danger">({{ audioTimer }})</b>
            </h5>

            <h5 v-if="isRecording">
              {{
                audioTimer
                  ? $lang.voice_recorde_correct
                  : $lang.voice_recorde_notcorrect
              }}
            </h5>
          </div>

          <div class="d-flex">
            <b-button
              ref="start"
              variant="dark"
              class="d-flex align-items-center justify-content-center rounded-circle border-0 mx-1"
              style="width: 40px; height: 40px"
              @click="startRecording"
              :disabled="isRecording"
            >
              <span>
                <mdicon name="microphone-outline" size="24" />
              </span>
            </b-button>
            <b-button
              ref="stop"
              variant="dark"
              class="d-flex align-items-center justify-content-center rounded-circle border-0 mx-1"
              style="width: 40px; height: 40px"
              @click="stopRecording"
              :disabled="!isRecording"
            >
              <span>
                <mdicon name="stop" size="24" />
              </span>
            </b-button>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="6" class="text-center">
        <audio ref="recorder" muted="true" controls hidden></audio>
        <audio ref="player" controls hidden></audio>
        <audio
          v-for="(item, i) in audios"
          :src="item"
          :key="i"
          controls
        ></audio>
        <div class="text-left w-75 m-auto" v-if="progressLoading">
          {{ $lang.search.loading_send }}
          <b-progress
            v-if="progress"
            :value="progress"
            max="100"
            show-progress
            :animated="progress == 100 ? false : true"
          />
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
    },
    audience_code: {
      type: [String, Number],
    },
    interview_master_name: {
      type: String,
    },
  },
  data() {
    return {
      progressLoading: false,
      mediaRecorder: null,
      stream: null,
      chunks: [],
      isRecording: false,
      recorderRef: null,
      playerRef: null,
      startRef: null,
      stopRef: null,
      timerInterval: null,
      audioTimer: null,
      auidoFile: null,
      progress: 0,
      constraints: {
        audio: true,
      },
      audios: [],
    };
  },
  inject: ["attachmentRepository"],
  methods: {
    async sendAudio(blob) {
      try {
        this.progressLoading = true;
        this.load = false;
        // set to prop
        const file_name = "interview_done";
        const file_id = this.audience_code;
        let file = new File([blob], `${this.name}.mp3`, {
          type: "audio/mpeg; codecs=lame",
        });

        const datetime = this.$moment(new Date()).format("jYYYY/jMM/jDD HH:mm");
        const caption = ` صوت مصاحبه توسط استاد  ${this.interview_master_name} (${datetime})`;
        const formData = new FormData();
        formData.append("file", file);
        formData.append("caption", caption);
        formData.append("attachment_type_id", 29);
        formData.append("attachment_type_name", "attachment_type_interview");

        const headers = { "Content-Type": "multipart/form-data" };
        const response = await this.attachmentRepository.create(
          formData,
          file_name,
          file_id,
          headers,
          true,
          {
            onUploadProgress: function (e) {
              this.progress = parseInt(Math.round((e.loaded * 100) / e.total));
            }.bind(this),
          }
        );
        this.flakUploadFile = true;
        this.$notify.success(this.$lang.upload_audio_file);
        this.$emit("getUploadFile");
        this.load = true;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.progressLoading = false;
      }
    },
    VoiceRecorder() {
      this.recorderRef = this.$refs.recorder;
      this.playerRef = this.$refs.player;
      this.startRef = this.$refs.start;
      this.stopRef = this.$refs.stop;
    },
    startTimer() {
      this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
    },
    convertYimestamp(unix_timestamp) {
      // Create a new JavaScript Date object based on the timestamp
      // multiplied by 1000 so that the argument is in milliseconds, not seconds.
      let date = new Date(unix_timestamp * 1000);
      // Hours part from the timestamp
      let hours = date.getHours();
      // Minutes part from the timestamp
      let minutes = "0" + date.getMinutes();
      // Seconds part from the timestamp
      let seconds = "0" + date.getSeconds();

      // Will display time in 10:30:23 format
      let formattedTime =
        hours + ":" + minutes.substr(-2) + ":" + seconds.substr(-2);
    },
    prettyTime(t) {
      let minutes = Math.floor(t / 60);
      if (minutes < 10) minutes = "0" + minutes;
      let seconds = Math.floor(t % 60);
      if (seconds < 10) seconds = "0" + seconds;
      return `${minutes}:${seconds}`;
    },

    handleSuccess(stream) {
      this.stream = stream;
      stream.oninactive = () => {};
      this.$refs.recorder.srcObject = stream;
      this.startTimer();
      let options = {
        mimeType: "audio/webm;codec=pcm",
      };
      this.mediaRecorder = new MediaRecorder(stream, options);
      this.mediaRecorder.ondataavailable = (e) =>
        this.onMediaRecorderDataAvailable(e);
      this.mediaRecorder.onstop = (e) => this.onMediaRecorderStop(e);
      this.$refs.recorder.onaudioprocess = (e) => this.onProcess(e);

      this.$refs.recorder.ontimeupdate = (e) => {
        let time = this.$refs.recorder.currentTime;
        this.audioTimer = this.prettyTime(time);
      };

      this.$refs.recorder.play();
      this.$refs.recorder.muted = true;
      this.mediaRecorder.start();
    },
    ontimeupdate(e) {},

    onMediaRecorderDataAvailable(e) {
      this.chunks.push(e.data);
    },

    onMediaRecorderStop(e) {
      const blob = new Blob(this.chunks, {
        type: "audio/webm; codecs=lame",
      });
      this.sendAudio(blob);

      const audioURL = window.URL.createObjectURL(blob);
      this.$refs.player.src = audioURL;
      this.audios.push(audioURL);
      this.chunks = [];
      this.stream.getAudioTracks().forEach((track) => track.stop());
      this.stream = null;
    },
    // اعلام شروع ضبط صدا
    startRecording() {
      this.isRecording = true;
      this.$refs.player.src = "";
      navigator.mediaDevices
        .getUserMedia(this.constraints)
        .then((stream) => {
          this.handleSuccess(stream);
          this.$emit("startRecording");
        })
        .catch((err) => this.$notify.error(this.$lang.audioRecorderException));
    },
    pauseRecording() {
      this.mediaRecorder.pause();
      this.$refs.recorder.pause();
    },
    stopRecording() {
      this.isRecording = false;
      this.$refs.recorder.pause();
      this.mediaRecorder.stop();
    },
  },
  created() {
    this.VoiceRecorder();
  },
};
</script>

<style lang="scss">
.record_btn {
  width: 45px;
  height: 45px;
  font-size: 25px;
  color: #ffffff;
  background: #424242;
  border: 2px solid #ffffff;
  border-radius: 50%;
  cursor: pointer;
  -webkit-transition: 0.15s linear;
  transition: 0.15s linear;
  line-height: 0;
}

.Rec_circle {
  width: 45px;
  height: 45px;

  font-size: 25px;
  color: #e74c3c;

  border: 2px solid #e74c3c;
  border-radius: 50%;
  cursor: pointer;
  transition: 0.15s linear;
}

.record_btn:hover {
  transition: 0.15s linear;
  transform: scale(1.05);
}

.record_btn:active {
  background: #f5f5f5;
}

.Rec_circle {
  animation-name: pulse;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes pulse {
  0% {
    box-shadow: 0px 0px 5px 0px rgba(173, 0, 0, 0.3);
  }

  65% {
    box-shadow: 0px 0px 5px 13px rgba(173, 0, 0, 0.3);
  }

  90% {
    box-shadow: 0px 0px 5px 13px rgba(173, 0, 0, 0);
  }
}
</style>
